import React from "react";
import { AvoidanceZone } from "../../types";
import { HereMapRectangle } from "./here-map-rectangle";
import { HereMapColors } from '../../styles/agistics-colors';

export const AvoidanceZoneBox = ({avoidanceZone}: {
    avoidanceZone: AvoidanceZone,
}) => (
    <HereMapRectangle
        pointA={{ lat: avoidanceZone.boundingBox.topLeft.latitude, lng: avoidanceZone.boundingBox.topLeft.longitude }}
        pointB={{ lat: avoidanceZone.boundingBox.bottomRight.latitude, lng: avoidanceZone.boundingBox.bottomRight.longitude }}
        strokeColor={avoidanceZone.organizationId ? HereMapColors.AVOIDANCE_ZONE : HereMapColors.GLOBAL_AVOIDANCE_ZONE}
        type='avoidance'
        changeable={false}
    >
        <div>
            {/* paddingBottom unit uses px so weird incremental values don't cause InfoBubble body/tail separation */}
            <span className='map-tooltip-label-name' style={{ paddingBottom: '4px' }}>{avoidanceZone.name}</span>
            {avoidanceZone.description && <span className='map-tooltip-label-desc'>{avoidanceZone.description}</span>}
        </div>
    </HereMapRectangle>
)